import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import Checkout from './components/Checkout';
import AboutPage from './pages/AboutPage';
import ContactsPage from './pages/ContactsPage';
import PrivacyPage from './pages/PrivacyPage';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import PaymentPage from './pages/PaymentPage';
import VinPage from './pages/VinPage';
import ReviewsPage from './pages/ReviewsPage';

import { useCart } from './context/CartContext';

function App() {
    const { items } = useCart();
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
               
                <Route path="/zapchastyny" element={<ProductPage />} />
                <Route path="/zapchastyny/:category" element={<ProductPage />} />
                <Route path="/zapchastyny/:category/:brand" element={<ProductPage />} />
                <Route path="/zapchastyny/:category/:brand/:model" element={<ProductPage />} />
                <Route path="/search" element={<ProductPage />} />
                <Route path="/category/:category_id" element={<ProductPage />} />
                <Route path="/model/:model_id" element={<ProductPage />} />
                <Route path="/products/:slug" element={<ProductDetailPage />} />
                
                <Route path="/room-for-big-guys-qmttydsra-53231998/login" element={<LoginPage />} />
                
                <Route 
                    path="/room-for-big-guys-qmttydsra-53231998" 
                    element={
                        <ProtectedRoute>
                            <AdminPage />
                        </ProtectedRoute>
                    }
                />
                
                <Route path="/vin-search" element={<VinPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPage />} />
                <Route path="/return-policy" element={<ReturnPolicyPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/checkout" element={<Checkout />} />
                
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

export default App;